import { Link } from 'react-router-dom';
import { StateMessage } from '@/components/ui/StateMessage';

export function NotFoundPage() {
	return (
		<div className="mt-16">
			<StateMessage
				icon="🐾"
				title="404 — Không tìm thấy trang"
				description="Đường dẫn này không tồn tại, hoặc phim đã bị xoá khỏi kho."
				action={
					<Link
						to="/"
						className="rounded-lg bg-accent px-4 py-2 text-sm font-bold text-white"
					>
						Về trang chủ
					</Link>
				}
			/>
		</div>
	);
}
